import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestfulEndpoint } from '../../services/restful-endpoint.service';
import { BaseResponse } from '../../models/shared.model';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ProjectReportsService {
  allProjects: any[] = [];
  totalAllProjects: number;
  areAllProjectsLoading: boolean = false;

  constructor(
    private _endPoint: RestfulEndpoint,
    private http: HttpClient,
    private _toastrService: ToastrService,
  ) {}

  getReportsOfProjects(page: number, per_page: number): Observable<BaseResponse<any>> {
    let params = { page: page, per_page: per_page };
    return this._endPoint.get('progressReports', params);
  }

  saveProjectReports(data: FormData): Observable<BaseResponse<any>> {
    return this._endPoint.post('v2/progressReports', data);
  }

  updateProjectReports(data: FormData, id: string): Observable<BaseResponse<any>> {
    return this._endPoint.post(`v2/progressReports/${id}`, data);
  }

  deleteProjectReport(id: string): Observable<BaseResponse<any>> {
    return this._endPoint.delete(`v2/progressReports/${id}`);
  }

  getProjectReport(id: string): Observable<BaseResponse<any>> {
    return this._endPoint.get(`progressReports/${id}`);
  }

  downloadReport(reportPath: string, reportName: string, isBlob?: boolean) {
    return new Promise((resolve, reject) => {
      this.http
        .get(reportPath, {
          responseType: 'blob',
          headers: {
            skipAuth: '',
          },
        })
        .subscribe(
          (blob: Blob) => {
            if (!isBlob) {
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = reportName;
              link.click();
              // Clean up
              URL.revokeObjectURL(link.href);
            }

            resolve(isBlob ? blob : true);
          },
          () => {
            reject(false);
            // Handle error here
          },
        );
    });
  }

  searchProjects(pageNo?: number, project_name?: string) {
    this.areAllProjectsLoading = true;
    const page = pageNo ?? 1;
    return new Promise((resolve, reject) => {
      this._endPoint
        .get('progressReports/projects', {
          page: page,
          name: project_name,
          is_archived: 0,
        })
        .subscribe({
          next: (res) => {
            this.allProjects = page === 1 ? res.data : this.allProjects.concat(res.data);
            this.areAllProjectsLoading = false;
            this.totalAllProjects = res.meta_data.total_items;
            resolve(res);
          },
          error: (err) => {
            this.areAllProjectsLoading = false;
            const errors = err?.error?.errors;

            if (Array.isArray(errors)) {
              errors.forEach((errorMessage: string) => {
                this._toastrService.error(errorMessage);
              });
            } else {
              this._toastrService.error(
                err?.error?.message || err?.message || 'Something went wrong, please try again.',
              );
            }

            reject(err?.error || err);
          },
        });
    });
  }
}
